import { RadioGroup, RadioGroupItem } from 'components/ui/radio-group';
import { Label } from 'components/ui/label';
import { WORK_PREFERENCES, WorkPreference } from 'constants/collab-club';
import { Artist } from 'types';
import { useTranslation } from 'react-i18next';

interface WorkPreferenceStepProps {
  profile: Artist;
  value: WorkPreference;
  onChange: (value: WorkPreference) => void;
}

export function WorkPreferenceStep({ profile, value, onChange }: WorkPreferenceStepProps) {
  const { t } = useTranslation('collab-club');

  return (
    <div className="space-y-6">
      <div className="">
        <h3 className="text-lg font-semibold text-gray-900">{t('project_types')}</h3>
      </div>

      <RadioGroup value={value} onValueChange={onChange} className="space-y-2">
        {Object.entries(WORK_PREFERENCES).map(([key, label]) => (
          <div key={key} className="flex items-center space-x-3">
            <RadioGroupItem value={key} id={key} />
            <Label
              htmlFor={key}
              className="cursor-pointer flex-1 text-base font-medium leading-none peer-disabled:cursor-not-allowed peer-disabled:opacity-70"
            >
              <div className="font-medium">{t(`work_preference_${key}`)}</div>
            </Label>
          </div>
        ))}
      </RadioGroup>
    </div>
  );
}
